import { useEffect, type PropsWithChildren } from "react"
import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import resourcesToBackend from "i18next-resources-to-backend"
import ISO6391 from "iso-639-1"

import { useAppSelector } from "@/lib/hooks"
import { useReduxState } from "@/hooks/use_redux_state"
import arLanguage from "../locales/ar.json"
import enLanguage from "../locales/en.json"
import heLanguage from "../locales/he.json"
import jaLanguage from "../locales/ja.json"

const bundledResources: Record<string, unknown> = {
  en: enLanguage,
  he: heLanguage,
  ar: arLanguage,
  ja: jaLanguage,
}

const localBackend = resourcesToBackend((lng: string) => bundledResources[lng])

void i18n
  .use(initReactI18next)
  .use(localBackend)
  .init({
    react: {
      useSuspense: false,
    },
  })

const I18Provider = ({ children }: PropsWithChildren) => {
  const [currentLanguageCode, setCurrentLanguageCode] = useReduxState({ key: "currentLanguageCode" })
  const configuration = useAppSelector((state) => state.configuration)

  useEffect(() => {
    if (!currentLanguageCode && configuration) {
      setCurrentLanguageCode(ISO6391.getCode(configuration.defaultLanguage))
    }
    if (currentLanguageCode && currentLanguageCode !== i18n.language) {
      void i18n.changeLanguage(currentLanguageCode)
    }
  }, [currentLanguageCode, configuration, setCurrentLanguageCode])

  return children
}

export default I18Provider
